import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import ROUTES from 'src/constants/routes'
import { Register } from 'src/pages/Register'
import { Login } from 'src/pages/Login'
import { ResetPassword } from 'src/pages/ResetPassword'
import { ChangePassword } from 'src/pages/ChangePassword'
import { ConfirmPhoneVerification } from 'src/pages/ConfirmPhoneVerification'
import { ConfirmEmailVerification } from 'src/pages/ConfirmEmailVerification'
import { Confirmations } from 'src/pages/Protected'
import { NotFound } from 'src/pages/NotFound'
import { ProtectedRoute } from 'src/components/ProtectedRoute'
import { ProtectedLayout } from './ProtectedLayout'
import { ROUTES_CONFIG, MenuPermission } from './routes.config'

// ============================================
// SISTEMA DE ROTAS
// ============================================
//
// As rotas são configuradas de forma declarativa no arquivo routes.config.tsx
// Este arquivo apenas renderiza as rotas baseado naquela configuração.
//
// Para adicionar/modificar rotas, edite routes.config.tsx
//
// ============================================

// ============================================
// RENDERIZAÇÃO RECURSIVA DE ROTAS
// ============================================

const renderRoute = (route: MenuPermission, index: number) => {
  const { path, element, allowedFor, children } = route

  return (
    <Route key={path || index} element={<ProtectedRoute roles={allowedFor} />}>
      <Route path={path} element={element}>
        {children?.map((child, childIndex) => {
          if (child.index) {
            return (
              <Route
                key={`index-${childIndex}`}
                index
                element={<ProtectedRoute roles={child.allowedFor}>{child.element}</ProtectedRoute>}
              />
            )
          }

          return (
            <Route
              key={child.path || childIndex}
              path={child.path}
              element={<ProtectedRoute roles={child.allowedFor}>{child.element}</ProtectedRoute>}
            />
          )
        })}
      </Route>
    </Route>
  )
}

export const AppRoutes: React.FC = () => (
  <Routes>
    {/* PUBLIC */}
    <Route path={ROUTES.AUTH.LOGIN} element={<Login />} />
    <Route path={ROUTES.AUTH.REGISTER} element={<Register />} />
    <Route path={ROUTES.AUTH.RESET_PASSWORD} element={<ResetPassword />} />
    <Route path={ROUTES.AUTH.CHANGE_PASSWORD} element={<ChangePassword />} />
    <Route path={ROUTES.AUTH.CONFIRM_PHONE} element={<ConfirmPhoneVerification />} />
    <Route path={ROUTES.AUTH.CONFIRM_EMAIL} element={<ConfirmEmailVerification />} />
    <Route path={ROUTES.AUTH.CONFIRMATIONS} element={<Confirmations />} />

    {/* PRIVATE */}
    <Route element={<ProtectedLayout />}>
      <Route path={ROUTES.ROOT} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      {ROUTES_CONFIG.map((route, index) => renderRoute(route, index))}
      <Route path='*' element={<NotFound />} />
    </Route>
  </Routes>
)

export default AppRoutes
